import { render } from "./News_en_m.vue?vue&type=template&id=26019986"
import script from "./News_en_m.vue?vue&type=script&lang=js"
export * from "./News_en_m.vue?vue&type=script&lang=js"
script.render = render

export default script